import { useQuery } from "@apollo/client";
import { GET_ORGANISATION_BY_SHORT_NAME } from "../../../graphql/organisation";
import { useHistory, useParams } from "react-router-dom";
import { OrganisationRootSkeleton } from "./OrganisationRootSkeleton";
import { useEffect } from "react";
import * as NotificationActions from "../../../actions/notification";
import { useDispatch } from "react-redux";
import { OrganisationProvider } from "../../providers/OrganisationProvider";
import { OrganisationRootContent } from "../../layout/organisation/OrganisationRootContent";

const OrganisationRoot = ({ children }) => {
    const { shortName } = useParams();
    const history = useHistory();
    const dispatch = useDispatch();
    const { data, error } = useQuery(GET_ORGANISATION_BY_SHORT_NAME, { variables: { shortName }, fetchPolicy: "cache-and-network", nextFetchPolicy: "cache-first" }),
        organisation = data && data.organisationByShortName;

    useEffect(() => {
        if ((data && !data.organisationByShortName) || error) {
            dispatch(NotificationActions.warn("It looks like we can't find what you are looking for! Perhaps you were looking for one of our organisations?"));
            return history.replace(`/organisations?search=${shortName}`);
        }
    }, [data, error]);

    if (!organisation) return <OrganisationRootSkeleton />;

    return(
        <OrganisationProvider value={{ organisation }}>
            <OrganisationRootContent organisation={organisation}>
                {children}
            </OrganisationRootContent>
        </OrganisationProvider>
    );
};
export default OrganisationRoot;
